import { AgentConversationRead } from '../store/schemas'
import { AgentConversation, AgentConversationsState } from '../store/slice'

/**
 * Resolves an AgentConversation entry from the given AgentConversationRead.
 *
 * - If the conversation doesn't exist, returns a fully initialized AgentConversation.
 * - If it exists and `updated_at` has changed, returns an updated conversation that merges
 *   the new server fields into the existing object, preserving local AgentConversation fields.
 * - If `updated_at` is unchanged, returns the existing conversation without any changes.
 *
 * @param state - The current AgentConversationsState
 * @param conversationRead - An AgentConversationRead object (from the server)
 * @returns An AgentConversation object (new, updated, or unchanged)
 */
export function createOrUpdateConversationFromServerRead(state: AgentConversationsState, conversationRead: AgentConversationRead): AgentConversation {
  const existingConversation = state.conversations[conversationRead.id]

  // If the conversation doesn't exist, initialize it with default values
  if (!existingConversation) {
    const newConversation: AgentConversation = {
      ...conversationRead,
      lastRefresh: null,
      isLoading: false,
      loadError: null,
    }

    return newConversation

    // If the conversation exists
  } else {
    // If the updated_at date is different, update the conversation
    if (existingConversation.updated_at !== conversationRead.updated_at) {
      // Update only the AgentConversationRead fields
      Object.assign(existingConversation, conversationRead)
    }

    // Return the existing conversation, whether it was updated or not
    return existingConversation
  }
}
